import { ActionType, createAction } from 'typesafe-actions';

export const omjsActions = {
    setViewInstance: createAction('OMJS_SET_VIEW_INSTANCE')<omjs.View>()
};

export type TOmjsActions = ActionType<typeof omjsActions>;
